import { useCallback, useRef, useState } from 'react';

/**
 * Ensures one in-flight user action at a time.
 * Disables repeat clicks / Enter submits until the promise settles.
 */
export function useActionGuard() {
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);

  const run = useCallback(async <T>(action: () => Promise<T>): Promise<T | undefined> => {
    if (busyRef.current) return undefined;
    busyRef.current = true;
    setBusy(true);
    try {
      return await action();
    } finally {
      busyRef.current = false;
      setBusy(false);
    }
  }, []);

  return { busy, run };
}
